import { render } from "./ExportPayments.vue?vue&type=template&id=473080a8"
import script from "./ExportPayments.vue?vue&type=script&lang=js"
export * from "./ExportPayments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__